import { AllActionType } from '@src/types/redux';

export const isActionType = (currentActionType: string, is: AllActionType) =>
  currentActionType === is;
